import { Onboarding } from 'types'

export const boards: { [key: string]: Onboarding } = {
  palmistry: 'palmistry',
  compatibility: 'compatibility',
}
